(() => {
  if (window.__amsExtra) { window.__amsExtra.scan(); return; }
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const COLORS = ['#6869ac', '#fa8334', '#d8cc34'];
  const touchUI = !fine.matches;
  const mobileMQ = matchMedia('(max-width: 760px)');

  /* ---------- Titoli magnetici ---------- */
  function splitTitle(h) {
    if (h.dataset.amsSplit) return null;
    h.dataset.amsSplit = '1';
    const label = h.textContent.replace(/\s+/g, ' ').trim();
    const wrap = document.createElement('span');
    wrap.setAttribute('aria-hidden', 'true');
    const chars = []; let n = 0;
    const addText = (text) => {
      text.split(/(\s+)/).forEach(part => {
        if (!part) return;
        if (/^\s+$/.test(part)) { wrap.appendChild(document.createTextNode(' ')); return; }
        const w = document.createElement('span'); w.className = 'ams-word';
        [...part].forEach(c => {
          const s = document.createElement('span'); s.className = 'ams-ch'; s.textContent = c;
          s.style.setProperty('--i', n); s.style.setProperty('--c', COLORS[n % 3]);
          w.appendChild(s); chars.push({ el: s, x: 0, y: 0, r: 0, sc: 1, k: 0, vx: 0, vy: 0 }); n++;
        });
        wrap.appendChild(w);
      });
    };
    [...h.childNodes].forEach(node => {
      if (node.nodeType === 3) addText(node.textContent);
      else if (node.nodeName === 'BR') wrap.appendChild(document.createElement('br'));
      else if (node.nodeType === 1) addText(node.textContent);
    });
    h.setAttribute('aria-label', label);
    h.textContent = ''; h.appendChild(wrap); h.classList.add('is-magnet');
    return chars;
  }
  /* titoli che non escono dallo schermo */
  function fit(h) {
    if (h.dataset.amsFit) return; h.dataset.amsFit = '1';
    const run = () => {
      h.style.fontSize = '';
      const words = [...h.querySelectorAll('.ams-word, .amp-word')];
      const box = h.clientWidth; if (!box || !words.length) return;
      const widest = Math.max(...words.map(w => w.scrollWidth));
      if (widest > box) h.style.fontSize = (parseFloat(getComputedStyle(h).fontSize) * box / widest * .97).toFixed(1) + 'px';
    };
    run(); addEventListener('resize', run);
    if (document.fonts) document.fonts.ready.then(run);
  }
  function magnet(h) {
    const chars = splitTitle(h);
    fit(h);
    if (!chars || reduce.matches) return;
    chars.forEach(c => { c.fx = 0; c.fy = 0; });
    let px = -1e4, py = -1e4, frame = 0, active = false;
    function step() {
      frame = 0; let moving = false;
      const size = Math.max(.55, parseFloat(getComputedStyle(h).fontSize) / 80);
      const R = 170 * size, PUSH = 26 * size;
      chars.forEach(c => {
        const b = c.el.getBoundingClientRect();
        const cx = b.left + b.width / 2 - c.fx, cy = b.top + b.height / 2 - c.fy;
        const dx = cx - px, dy = cy - py, d = Math.hypot(dx, dy) || 1;
        const f = active ? Math.max(0, 1 - d / R) : 0, e = f * f * (3 - 2 * f);
        const tx = dx / d * e * PUSH, ty = dy / d * e * PUSH - e * 6 * size;
        const tr = (dx / d) * e * -14, ts = 1 + e * .16, tk = e > .1 ? 100 : 0;
        c.vx = (c.vx + (tx - c.x) * .18) * .72; c.vy = (c.vy + (ty - c.y) * .18) * .72;
        c.x += c.vx; c.y += c.vy; c.r += (tr - c.r) * .2; c.sc += (ts - c.sc) * .2; c.k += (tk - c.k) * .22;
        c.fx = c.x; c.fy = c.y;
        const fr = c.r, fk = c.k;
        const st = c.el.style;
        st.setProperty('--x', c.fx.toFixed(2) + 'px'); st.setProperty('--y', c.fy.toFixed(2) + 'px');
        st.setProperty('--r', fr.toFixed(2) + 'deg'); st.setProperty('--s', c.sc.toFixed(3)); st.setProperty('--k', fk.toFixed(1) + '%');
        if (Math.abs(c.x) > .05 || Math.abs(c.y) > .05 || Math.abs(c.vx) > .05 || c.k > .5) moving = true;
      });
      if (active || moving) frame = requestAnimationFrame(step);
    }
    const wake = () => { if (!frame) frame = requestAnimationFrame(step); };
    const zone = h.closest('.ams-panel') || h;
    zone.addEventListener('pointermove', e => { if (e.pointerType !== 'mouse') return; px = e.clientX; py = e.clientY; active = true; wake(); }, { passive: true });
    zone.addEventListener('pointerleave', () => { active = false; wake(); });
    if (touchUI) {
      const touch = e => { const p = e.touches[0]; if (!p) return; px = p.clientX; py = p.clientY; active = true; wake(); };
      const end = () => { active = false; wake(); };
      h.addEventListener('touchstart', touch, { passive: true });
      h.addEventListener('touchmove', touch, { passive: true });
      h.addEventListener('touchend', end); h.addEventListener('touchcancel', end);
    }
  }

  /* ---------- Home: mazzo progetti ---------- */
  function deck(root) {
    if (root.dataset.amsInit) return; root.dataset.amsInit = '1';
    const cards = [...root.querySelectorAll('.ams-card')];
    const n = cards.length; if (!n) return;
    const counter = root.querySelector('[data-deck-count]');
    const ms = parseInt(root.dataset.speed || '3200', 10);
    root.style.setProperty('--ams-deck-ms', ms + 'ms');
    let i = 0, timer = 0, paused = false, busy = false;
    const pad = v => String(v).padStart(2, '0');
    function layout() {
      cards.forEach((c, idx) => {
        const k = (idx - i + n) % n;
        c.classList.toggle('is-front', k === 0);
        c.tabIndex = k === 0 ? 0 : -1;
        c.setAttribute('aria-hidden', k === 0 ? 'false' : 'true');
        const cfg = [[0, 0, 0, 1, 1], [26, 10, 5, .94, .9], [-22, 20, -6, .88, .75], [10, 28, 3, .82, 0]][Math.min(k, 3)];
        c.style.zIndex = String(n - k);
        c.style.opacity = String(k > 2 ? 0 : 1);
        c.style.filter = k === 0 ? 'none' : `brightness(${cfg[4] * .12 + .88}) saturate(.85)`;
        c.style.transform = `translate(${cfg[0]}px, ${cfg[1]}px) rotate(${cfg[2]}deg) scale(${cfg[3]})`;
      });
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(n);
    }
    function go(dir) {
      if (busy) return; busy = true;
      const front = cards[i];
      if (dir > 0 && !reduce.matches) {
        front.classList.add('is-out');
        setTimeout(() => { front.classList.remove('is-out'); busy = false; }, 650);
      } else busy = false;
      i = (i + dir + n) % n; layout(); restart();
    }
    function restart() {
      clearTimeout(timer); root.classList.remove('is-playing');
      if (paused || reduce.matches || n < 2) return;
      void root.offsetWidth; root.classList.add('is-playing');
      timer = setTimeout(() => go(1), ms);
    }
    root.querySelector('[data-deck-next]')?.addEventListener('click', () => go(1));
    root.querySelector('[data-deck-prev]')?.addEventListener('click', () => go(-1));
    root.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { paused = true; restart(); } });
    root.addEventListener('pointerleave', () => { paused = false; restart(); layout(); });
    root.addEventListener('focusin', () => { paused = true; restart(); });
    root.addEventListener('focusout', () => { paused = false; restart(); });
    function tilt(x, y) {
      const f = cards[i];
      if (reduce.matches) return;
      f.style.transform = `perspective(1200px) rotateY(${(x * 10).toFixed(2)}deg) rotateX(${(-y * 8).toFixed(2)}deg) scale(1.02)`;
    }
    root.addEventListener('pointermove', e => {
      if (e.pointerType !== 'mouse') return;
      const r = root.getBoundingClientRect();
      tilt((e.clientX - r.left) / r.width - .5, (e.clientY - r.top) / r.height - .5);
    }, { passive: true });
    let x0 = null, moved = false;
    root.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; moved = false; }, { passive: true });
    root.addEventListener('touchmove', e => { if (x0 !== null && Math.abs(e.touches[0].clientX - x0) > 12) moved = true; }, { passive: true });
    root.addEventListener('touchend', e => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });
    cards.forEach(c => c.addEventListener('click', e => { if (moved) { e.preventDefault(); moved = false; } }));
    new IntersectionObserver(es => { paused = !es[0].isIntersecting; restart(); }).observe(root);
    document.addEventListener('visibilitychange', () => { paused = document.hidden; restart(); });
    layout(); restart();
  }

  /* ---------- Timeline con filo ---------- */
  function timeline(root) {
    if (root.dataset.amsInit) return; root.dataset.amsInit = '1';
    const svg = root.querySelector('.ams-tl-line');
    const path = root.querySelector('.ams-tl-path'), track = root.querySelector('.ams-tl-track');
    const items = [...root.querySelectorAll('.ams-tl-item')];
    if (!svg || !items.length) return;
    let marks = [], H = 0, frame = 0, t = 0, last = 0, visible = false;
    function curve(pts) {
      const f = p => p[0].toFixed(1) + ',' + p[1].toFixed(1);
      let d = 'M' + f(pts[0]);
      for (let k = 1; k < pts.length - 1; k++) { const a = pts[k], b = pts[k + 1]; d += 'Q' + f(a) + ' ' + f([(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]); }
      return d + 'L' + f(pts[pts.length - 1]);
    }
    function measure() {
      const r = root.getBoundingClientRect(); H = r.height;
      svg.setAttribute('viewBox', `0 0 ${r.width} ${H}`);
      marks = items.map(it => { const d = it.querySelector('.ams-tl-dot').getBoundingClientRect(); return [d.left + d.width / 2 - r.left, d.top + d.height / 2 - r.top]; });
      const grad = svg.querySelector('linearGradient');
      if (grad) { grad.setAttribute('y1', '0'); grad.setAttribute('y2', String(H)); }
      shape(0); progress();
    }
    function shape(time) {
      if (!marks.length) return;
      const x0 = marks[0][0], wide = innerWidth > 760, amp = wide ? 46 : 16;
      const pts = [[x0, 0]];
      marks.forEach((m, k) => {
        const prev = k ? marks[k - 1] : [x0, 0];
        const midY = (prev[1] + m[1]) / 2, side = k % 2 ? 1 : -1;
        const wob = Math.sin(time * .9 + k * 1.7) * (wide ? 10 : 4);
        pts.push([m[0] + side * amp + wob, midY]); pts.push(m);
      });
      const end = marks[marks.length - 1];
      pts.push([end[0] + (wide ? 40 : 12), end[1] + (H - end[1]) / 2]); pts.push([end[0], H]);
      const d = curve(pts); path.setAttribute('d', d); track.setAttribute('d', d);
    }
    function progress() {
      const r = root.getBoundingClientRect();
      const reach = innerHeight * .62 - r.top;
      const p = Math.min(1, Math.max(0, reach / H));
      path.style.setProperty('--ams-draw', (1 - p).toFixed(4));
      items.forEach((it, k) => { const on = marks[k] && marks[k][1] <= reach + 4; it.classList.toggle('is-on', !!on); it.style.setProperty('--ams-dot', COLORS[k % 3]); });
    }
    function tick(now) {
      frame = 0; if (!visible || reduce.matches || document.hidden) return;
      const dt = Math.min((now - last) / 1000 || .016, .05); last = now; t += dt;
      shape(t); frame = requestAnimationFrame(tick);
    }
    const wake = () => { if (!frame && visible && !reduce.matches) { last = performance.now(); frame = requestAnimationFrame(tick); } };
    root.classList.add('is-ready');
    new ResizeObserver(measure).observe(root);
    addEventListener('scroll', progress, { passive: true });
    addEventListener('resize', measure);
    new IntersectionObserver(es => { visible = es[0].isIntersecting; wake(); }).observe(root);
    measure();
  }

  /* ---------- Mobile: indice progetti + entrata ---------- */
  function stack(list) {
    if (list.dataset.amsStack) return; list.dataset.amsStack = '1';
    const cards = [...list.children].filter(c => c.classList.contains('ams-project'));
    if (cards.length < 2) return;
    const bar = document.createElement('nav');
    bar.className = 'ams-pindex'; bar.setAttribute('aria-label', 'Indice progetti');
    const chips = cards.map((c, i) => {
      const t = (c.querySelector('h3')?.textContent || '').trim();
      if (!c.id) c.id = 'progetto-' + (i + 1);
      const a = document.createElement('a'); a.href = '#' + c.id; a.textContent = t;
      a.style.setProperty('--c', COLORS[i % 3]);
      a.addEventListener('click', ev => {
        ev.preventDefault();
        const y = c.getBoundingClientRect().top + scrollY - bar.offsetHeight - 16;
        scrollTo({ top: y, behavior: reduce.matches ? 'auto' : 'smooth' });
      });
      bar.appendChild(a); return a;
    });
    list.before(bar);
    let cur = -1;
    function mark(i) {
      if (i === cur) return; cur = i;
      chips.forEach((a, k) => a.classList.toggle('is-on', k === i));
      const a = chips[i]; if (a) bar.scrollTo({ left: a.offsetLeft - (bar.clientWidth - a.offsetWidth) / 2, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    const spy = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) mark(cards.indexOf(e.target)); }), { rootMargin: '-40% 0px -55% 0px' });
    cards.forEach(c => spy.observe(c));
    if (!reduce.matches && 'IntersectionObserver' in window) {
      list.classList.add('is-flow');
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -12% 0px' });
      cards.forEach(c => io.observe(c));
    }
  }

  /* ---------- Menu mobile a schermo intero ---------- */
  function menus() {
    document.querySelectorAll('details.ams-mobile-nav, details.amp-mobile-nav').forEach(d => {
      if (d.dataset.amsMenu) return; d.dataset.amsMenu = '1';
      const nav = d.querySelector('nav'); if (!nav) return;
      nav.classList.add('ams-fullnav');
      nav.insertAdjacentHTML('afterbegin', '<svg class="ams-fullnav-ribbon" viewBox="0 0 400 800" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false"><defs><linearGradient id="ams-fn-grad" x1="0" y1="0" x2="0" y2="1"><stop stop-color="#fa8334"/><stop offset=".55" stop-color="#d8cc34"/><stop offset="1" stop-color="#f0eeeb"/></linearGradient></defs><path pathLength="1" d="M440,70 C260,30 110,150 200,260 C300,380 50,420 90,545 C130,670 340,600 305,725 C285,800 160,820 120,870"/></svg>');
      [...nav.querySelectorAll('a')].forEach((a, i) => a.style.setProperty('--i', i));
      d.addEventListener('toggle', () => document.documentElement.classList.toggle('ams-menu-open', d.open));
      nav.addEventListener('click', e => { if (e.target.closest('a')) d.open = false; });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && d.open) { d.open = false; d.querySelector('summary')?.focus(); } });
    });
  }

  /* ---------- Team: tocco e scroll ---------- */
  function team(root) {
    root.querySelectorAll('[data-portrait]').forEach(button => {
      if(button.dataset.ready)return;
      button.dataset.ready='1';
      button.addEventListener('click',()=>{
        const active=button.classList.toggle('is-alternate');
        button.setAttribute('aria-pressed',String(active));
      });
    });
  }

  /* ---------- Schizzo di colore al tocco ---------- */
  function splashes() {
    if (!touchUI || reduce.matches || window.__amsSplash) return; window.__amsSplash = 1;
    const layer = document.createElement('div'); layer.className = 'ams-splash-layer'; layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    document.addEventListener('click', e => {
      if (!e.clientX && !e.clientY) return;
      const g = document.createElement('span'); g.className = 'ams-splash';
      g.style.left = e.clientX + 'px'; g.style.top = e.clientY + 'px';
      for (let k = 0; k < 8; k++) {
        const d = document.createElement('i'), a = (k / 8) * Math.PI * 2 + Math.random() * .5, r = 26 + Math.random() * 30, s = 5 + Math.random() * 7;
        d.style.setProperty('--dx', (Math.cos(a) * r).toFixed(1) + 'px'); d.style.setProperty('--dy', (Math.sin(a) * r).toFixed(1) + 'px');
        d.style.background = COLORS[k % 3]; d.style.width = d.style.height = s.toFixed(1) + 'px';
        g.appendChild(d);
      }
      layer.appendChild(g); setTimeout(() => g.remove(), 750);
    }, { passive: true });
  }

  function compactHeaders() {
    document.querySelectorAll('.ams-nav,.amp-nav').forEach(header=>{
      if(header.dataset.compactReady)return;
      header.dataset.compactReady='1';
      const spacer=document.createElement('div');
      spacer.setAttribute('aria-hidden','true');
      spacer.hidden=true;
      header.before(spacer);
      let height=header.offsetHeight;
      function update(){
        const compact=window.scrollY>180;
        if(compact===header.classList.contains('is-compact'))return;
        if(compact){height=header.offsetHeight;spacer.style.height=height+'px';}
        spacer.hidden=!compact;
        header.classList.toggle('is-compact',compact);
      }
      addEventListener('scroll',update,{passive:true});
      addEventListener('resize',()=>{
        header.classList.remove('is-compact');spacer.hidden=true;
        height=header.offsetHeight;update();
      });
      update();
    });
  }

  function backToTop() {
    if(document.querySelector('.ams-back-top'))return;
    const source=document.querySelector('.ams-footer>a[href^="#ams-"],.amp-footer>a[href^="#amp-"]');
    if(!source)return;
    const button=document.createElement('button');
    button.type='button';button.className='ams-back-top';button.hidden=true;
    button.innerHTML=source.innerHTML;
    button.setAttribute('aria-label',source.textContent.trim());
    document.body.appendChild(button);
    const update=()=>{button.hidden=window.scrollY<400;};
    addEventListener('scroll',update,{passive:true});
    button.addEventListener('click',()=>{
      const target=document.querySelector('.ams-wordmark,.amp-wordmark');
      if(target)target.focus({preventScroll:true});
      window.scrollTo({top:0,behavior:reduce.matches?'instant':'smooth'});
    });
    update();
  }

  function teamThreads(){
    document.querySelectorAll('.ams-portrait-cluster').forEach((cluster,index)=>{
      if(cluster.querySelector('.ams-team-thread'))return;
      const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('class','ams-team-thread');svg.setAttribute('viewBox','0 0 580 470');
      svg.setAttribute('preserveAspectRatio','none');svg.setAttribute('aria-hidden','true');
      const id='ams-team-gradient-'+index;
      svg.innerHTML='<defs><linearGradient id="'+id+'" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#6869ac"/><stop offset=".5" stop-color="#fa8334"/><stop offset="1" stop-color="#d8cc34"/></linearGradient></defs><path pathLength="1" stroke="url(#'+id+')" d="M20 75 C75 15 180 175 245 88 S400 10 466 126 S390 287 287 220 S40 148 72 290 S265 445 360 379 S515 330 555 434"/>';
      cluster.append(svg);
      const observer=new IntersectionObserver(entries=>{
        if(entries.some(e=>e.isIntersecting)){cluster.classList.add('is-thread-visible');observer.disconnect();}
      },{threshold:.25});
      observer.observe(cluster);
    });
  }

  function exploreRibbons(){
    document.querySelectorAll('[data-explore]').forEach(el=>{
      if(el.classList.contains('is-explore-ready'))return;
      el.classList.add('is-explore-ready');
      const observer=new IntersectionObserver(entries=>{
        if(entries.some(e=>e.isIntersecting)){el.classList.add('is-explore-visible');observer.disconnect();}
      },{threshold:.15});
      observer.observe(el);
    });
  }

  function randomWorkPreviews(){
    document.querySelectorAll('.ams-explore--work').forEach(root=>{
      if(root.dataset.randomReady)return;
      const pool=root.querySelector('template[data-work-pool]');
      if(!pool)return;
      const cards=[...pool.content.querySelectorAll('.ams-work-node')];
      if(!cards.length)return;
      root.dataset.randomReady='1';
      for(let i=cards.length-1;i>0;i--){
        const j=Math.floor(Math.random()*(i+1));
        [cards[i],cards[j]]=[cards[j],cards[i]];
      }
      root.querySelectorAll('.ams-work-node').forEach(card=>card.remove());
      cards.slice(0,3).forEach(card=>root.appendChild(card.cloneNode(true)));
    });
  }

  function introThreadScroll(){
    document.querySelectorAll('.ams-panel--intro').forEach(panel=>{
      if(panel.dataset.threadScroll)return;
      panel.dataset.threadScroll='1';
      let frame=0;
      const update=()=>{
        frame=0;
        const rect=panel.getBoundingClientRect();
        const progress=reduce.matches?0:Math.max(0,Math.min(1,-rect.top/Math.max(1,rect.height)));
        panel.style.setProperty('--intro-thread-y',Math.round(progress*95)+'px');
        panel.style.setProperty('--intro-thread-r',(progress*18)+'deg');
      };
      const scroll=()=>{if(!frame)frame=requestAnimationFrame(update);};
      addEventListener('scroll',scroll,{passive:true});
      addEventListener('resize',scroll);
      reduce.addEventListener('change',update);
      update();
    });
  }

  function scan() {
    document.querySelectorAll('.ams-site[data-magnet="true"] .ams-panel h1, .ams-site[data-magnet="true"] .ams-panel > .ams-copy h2').forEach(magnet);
    document.querySelectorAll('[data-ams-deck]').forEach(deck);
    document.querySelectorAll('[data-ams-timeline]').forEach(timeline);
    document.querySelectorAll('.ams-site .ams-projects').forEach(stack);
    document.querySelectorAll('.ams-team, .ams-team-preview').forEach(team);
    document.querySelectorAll('.amp-title').forEach(h => { if (h.classList.contains('is-split')) fit(h); });
    menus(); splashes(); compactHeaders(); backToTop(); teamThreads(); randomWorkPreviews(); exploreRibbons(); introThreadScroll();
  }
  addEventListener('load', scan);
  window.__amsExtra = { scan };
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
})();
